<template>
  <transition name="modal">
    <div class="modal-wrapper" v-if="visible">
      <div class="page-overlay" @click="hideModal"></div>
      <div class="modal">
        <button class="modal-close" @click="hideModal">+</button>
        <component :is="dynamicComponent"></component>
      </div>
    </div>
  </transition>
</template>
<script>
import ContactUsModal from '@/components/modals/ContactUsModal.vue';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Modal',
  computed: {
    ...mapState({
      visible: 'modalVisible',
      modalComponent: 'modalComponent',
    }),
    dynamicComponent() {
      const componentMapping = {
        ContactUsModal,
      };
      return componentMapping[this.modalComponent];
    },
  },
  methods: {
    ...mapMutations(['hideModal']),
  },
  components: {
    ContactUsModal,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue